import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { BOOKING_URL } from "@/lib/site";
import { useLang } from "@/i18n";
import { IMAGES } from "@/content/images";

const FinalCTA = () => {
  const ref = useRef(null);
  const { t } = useLang();
  const d = t.finalCta;
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} data-testid="final-cta-section" className="relative flex min-h-[85vh] items-center overflow-hidden">
      <motion.img src={IMAGES.finalCta} alt="Two women in the Cabo Yoga & Fitness studio"
        data-testid="final-cta-image" loading="lazy" style={{ y: imgY }}
        className="absolute inset-0 h-full w-full scale-110 object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-charcoal/60 via-charcoal/30 to-transparent" />

      <div className="relative z-10 mx-auto w-full max-w-[1600px] px-6 md:px-12 py-32">
        <Reveal><p className="label-caps text-ivory/70">{d.label}</p></Reveal>
        <Reveal delay={0.1}>
          <h2 data-testid="final-cta-headline"
            className="mt-8 max-w-3xl font-display text-ivory text-5xl sm:text-6xl lg:text-[5.2rem] leading-[0.98] tracking-tight">
            {d.headingA} <span className="italic font-light">{d.headingB}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-md text-base md:text-lg leading-relaxed text-ivory/85">{d.copy}</p>
        </Reveal>
        <Reveal delay={0.3}>
          <a href={BOOKING_URL} data-testid="final-cta-book-button" className="btn-pill mt-12 bg-ivory text-charcoal hover:bg-sand">
            {d.cta}
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
